<template lang="pug">
  //- <svg class="block" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  //-     <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
  //-         <g id="Profile-Status-Green" transform="translate(-14.000000, -5.000000)" fill="currentColor">
  //-             <g id="Group-3">
  //-                 <g id="Group-2" transform="translate(2.000000, 1.000000)">
  //-                     <g id="Group" transform="translate(12.000000, 4.000000)">
  //-                         <circle id="Oval-7" cx="7.38461538" cy="3.69230769" r="3.69230769"></circle>
  //-                         <path d="M14.7692308,16 C14.7692308,11.9215895 11.4630258,8.61538462 7.38461538,8.61538462 C3.30620492,8.61538462 0,11.9215895 0,16" id="Oval-8"></path>
  //-                     </g>
  //-                 </g>
  //-             </g>
  //-         </g>
  //-     </g>
  //- </svg>
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.80775 2.76923C8.80775 4.02249 7.79178 5.03846 6.53852 5.03846C5.28526 5.03846 4.26929 4.02249 4.26929 2.76923C4.26929 1.51597 5.28526 0.5 6.53852 0.5C7.79178 0.5 8.80775 1.51597 8.80775 2.76923Z" stroke="currentColor"/>
    <path d="M12.0769 12C12.0769 8.9412 9.59727 6.46155 6.53846 6.46155C3.47965 6.46155 1 8.9412 1 12" stroke="currentColor"/>
  </svg>

</template>

<script>
export default {
  name: 'PersonIcon'
}
</script>

<style scoped>
svg{
  width:15px;
  height:16px;
}
</style>
